<template>
    <header class="m-navbar navbar-bottom-line-color border2" :class="classes" :style="{backgroundColor: bgcolor}">
      <!-- 左 -->
      <div class="navbar-item">
        <slot name="left"></slot>
      </div>

      <!-- 中 -->
      <div class="navbar-center-box">
        <div class="navbar-center">
          <template v-if="type == 'center'">
            <slot name="center"><span class="center-title" :style="{color: color}">{{title}}</span></slot>
          </template>
          <template v-else>
            <slot name="center">
              <span class="top-title" :style="{color: color}">{{title}}</span>
              <span class="tips" :style="{color: tipsColor}">{{tips}}</span>
            </slot>
          </template>
        </div>
      </div>

      <!-- 右 -->
      <div class="navbar-item">
        <slot name="right"></slot>
      </div>
    </header>
</template>

<script>
  import {isColor} from '../assets/utils';

  export default {
    name: 'navbar',
    props: {
      type: String,
      title: String,
      tips: String,
      fixed: Boolean,
      bgcolor: {
        validator(value) {
          let bgFlag = true;
          if (!value) {
            bgFlag = true;
          } else {
            bgFlag = isColor(value);
          }
          return bgFlag;
        },
        default: '#FFF'
      },
      color: {
        validator(value) {
          let colorFlag = true;
          if (!value) {
            colorFlag = true;
          } else {
            colorFlag = isColor(value);
          }
          return colorFlag;
        },
        default: 'rgb(68, 68, 68)'
      },
      tipsColor: {
        default: 'rgb(136, 136, 136)'
      }
    },
    computed: {
      classes() {
        return this.fixed ? 'navbar-fixed' : '';
      }
    }
  };
</script>

<style lang="less">
  @import "../assets/base.less";

  .m-navbar {
    position: relative;
    width:100%;
    height: 88px;
    z-index:1000;

    &.navbar-fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: @base-zindex * 100;
    }
  }

  .navbar-item {
    float: left;
    width: 14%;
    height: 100%;
    // padding: 0 32px;
    font-size: 36px;
    white-space: nowrap;
    overflow: hidden;
    color: inherit;
    &:first-child {

    }
    &:last-child {

    }
    > a {
      height: 88px;
    }
  }

  .navbar-center-box {
    float: left;
    width: 72%;
    height: 88px;
    line-height: 88px;

    .navbar-center {
      width: 100%;
      display: flex;
      .flex-direction(column);
      .justify-content(center);
      .align-items(center);
      height: inherit;

      .top-title {
        display: block;
        width: 100%;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgb(24, 24, 24);
        text-align: center;
        font-size: 30px;
      }

      .tips {
        display: block;
        width: 100%;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgb(136, 136, 136);
        text-align: center;
        font-size: 22px;
      }

      .center-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 36px;
        height: 88px;
        line-height: 88px;
        color: rgb(24, 24, 24);
      }
      img {
        height: 60%;
      }
    }
  }

  .back-icon:before, .next-icon:before, .menu-icon:before {
    display: inline-block;
    font-family: @iconfont-inlay;
    font-size: 40px;
    color: #777;
  }

  .back-icon {
    display: inline-block;
    width: 44px;
    height: 44px;
    margin-top: 22px;
    margin-left: 20px;
    background: url(../assets/images/icon-arrow.png) center center;
    background-size: cover;
  }

  .next-icon:before {
    content: '\e608';
  }

  .menu-icon:before {
    font-family: @iconfont-icons;
    content: '\e614';
  }

  .menu-icon {
    float: right;
    display: block;
    width: 44px;
    height: 44px;
    margin: 22px 30px 0 0;
  }
</style>



// WEBPACK FOOTER //
// NavBar.vue?5df31369